<template>
    <div id="personalCenter">
      <div style="height: 52px;background-color: #fff;"></div>
      <div class="content">
        <div class="top">
          <div class="account">
            <span class="top_left">车灯师账号</span>
            <span class="top_right">{{userInfo.userPhone | getPhone}}</span>
          </div>
          <div class="user mt15">
            <span class="top_left">用户名</span>
            <span class="top_right">{{userInfo.userName}}</span>
          </div>
        </div>
        <!--账号密码-->
        <div class="item">
          <div class="item_left">
            <img src="../../assets/image/icon_lock.png" alt="">
            <div class="ml20">
              <p class="pass_word">账号密码</p>
              <p class="safe mt10">用于保护账号安全</p>
            </div>
          </div>
          <div class="item_right" @click="changePassWord()">修改</div>
        </div>
        <!--安全手机-->
        <div class="item">
          <div class="item_left">
            <img src="../../assets/image/icon_mobile.png" alt="">
            <div class="ml20">
              <p class="pass_word">安全手机<span class="number ml20">{{userInfo.userPhone | getPhone}}</span></p>
              <p class="safe mt10">安全手机可用于登录车灯师账号，重置密码或其他安全验证</p>
            </div>
          </div>
          <div class="item_right" @click="phone = true">修改</div>
        </div>
      </div>
      <!--修改密码-->
      <div class="master" v-if="passWord">
        <div class="change_password">
          <div class="title">
            <i class="el-icon-circle-close-outline right" @click="passWord = false"></i>
            修改密码
          </div>
          <div class="details">
            <p class="code">原密码</p>
            <input class="mt10" v-model="oldWord" type="password" placeholder="请输入原密码">
            <p class="code" style="margin-top: 28px;">新密码</p>
            <input class="mt10" v-model="newWord" type="password" maxlength="16" placeholder="请输入新密码">
            <input class="mt15" v-model="input" type="password" placeholder="请再次输入新密码" @onblur="validation()">
            <p class="illustrate mt10" ref="illustrate">密码包含6-16位字母、数字</p>
          </div>
          <div class="btn">
            <button class="cancel" @click="passWord = false">取消</button>
            <button class="sure" @click="submit()">确定</button>
          </div>
        </div>
      </div>
      <!--绑定手机-->
      <div class="master" v-if="phone">
        <!--发送短信-->
        <!--<div class="binding_phone" v-if="false">-->
          <!--<div class="title">-->
            <!--<i class="el-icon-circle-close-outline right" @click="phone = false"></i>-->
            <!--验证身份-->
          <!--</div>-->
          <!--<div class="details">-->
            <!--<p class="auth_code">点击发送短信按钮，将发送一条含有数字验证码的短信至您的手机<span class="phone_num">188******39</span>用于验证身份。-->
            <!--</p>-->
            <!--<button class="send">发送短信</button>-->
          <!--</div>-->
        <!--</div>-->
        <!--验证身份-->
        <!--send-->
        <div class="validation" v-show="send">
          <div class="title">
            <i class="el-icon-circle-close-outline right" @click="phone = false"></i>
            验证身份
          </div>
          <div class="details">
            <p class="auth_code">点击获取验证码按钮，将发送含有数字验证码的短信至您的手机<span class="phone_num">{{userInfo.userPhone | getPhone}}</span>，用于验证身份。
            </p>
            <!--<p v-else class="auth_code">已发送一条含有数字验证码的短信至您的手机<span class="phone_num">188******39</span>，请输入短信中的验证码。-->
            <!--</p>-->
            <div class="box">
              <input class="randCode" v-model="randCode" type="number" placeholder="手机验证码">
              <send-btn class="sendBtn" :user-phone="userInfo.userPhone" rand-type="BBS_PHONE"></send-btn>
              <!--<div class="seconds">60s</div>-->
            </div>
            <button class="send" @click="compare()">验证</button>
          </div>
        </div>
        <div class="validation" v-show="!send">
          <div class="title">
            <i class="el-icon-circle-close-outline right" @click="phone = false"></i>
            绑定安全手机
          </div>
          <div class="details">
            <input v-model="newPhone" type="number" placeholder="请输入新手机号">
            <div class="box">
              <input class="randCode" v-model="randCode" type="number" placeholder="手机验证码">
              <send-btn class="sendBtn" :user-phone="newPhone" rand-type="BBS_PHONE"></send-btn>
              <!--<div class="seconds">60s</div>-->
            </div>
            <button class="send" @click="sure()">确定</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import * as types from '../../common/js/types'
import sendBtn from '../common/sendBtn.vue'
export default {
  name: 'personalCenter',
  data () {
    return {
      userInfo: {},
      passWord: false,
      phone: false,
      send: true,
      oldWord: '',
      newWord: '',
      input: '',
      randCode: '',
      newPhone: ''
    }
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    getUserInfo () {
      let that = this
      that.axios.post('/userInfo', {
        userId: that.$root.getUserId()
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.userInfo = response.data.value
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    changePassWord () {
      this.passWord = true
      this.oldWord = ''
      this.newWord = ''
      this.input = ''
    },
    validation () {
      if (this.newWord === this.input) {
        this.$refs.illustrate.innerText = '您的记忆力惊人，完全一致'
        this.$refs.illustrate.style.color = 'green'
      } else {
        this.$refs.illustrate.innerText = '两次密码输入不一致，请重新输入'
        this.$refs.illustrate.style.color = 'red'
      }
    },
    submit () {
      let that = this
      if (!that.input) {
        return that.$store.commit('setToastMsg', '请您再次确认密码')
      } else if (that.input !== that.newWord) {
        return that.$store.commit('setToastMsg', '两次密码输入不一致，请重新输入')
      }
      that.axios.post('/changePassWord', {
        userId: that.$root.getUserId(),
        newPassWord: that.newWord,
        passWord: that.oldWord
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$store.commit('setToastMsg', '修改成功')
          that.passWord = false
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    compare () {
      let that = this
      that.axios.post('/checkPhone', {
        userId: that.$root.getUserId(),
        randCode: that.randCode
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$store.commit('setToastMsg', '验证成功')
          that.randCode = ''
          that.send = false
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    sure () {
      let that = this
      that.axios.post('/changePhone', {
        userId: that.$root.getUserId(),
        randCode: that.randCode,
        newPhone: that.newPhone
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$store.commit('setToastMsg', '绑定成功')
          that.$store.commit(types.LOGIN, response.data.value)
          that.getUserInfo()
          that.phone = false
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  filters: {
    getPhone (num) {
      if (num) {
        return num.slice(0, 3) + '******' + num.slice(9)
      } else {
        return ''
      }
    }
  },
  components: {
    sendBtn
  }
}
</script>

<style scoped>
  #personalCenter{
    width: 100%;
    height: 100%;
    text-align: left;
    background-color: #f0f0f0;
  }
  .mt15{
    margin-top: 15px;
  }
  .mt10{
    margin-top: 10px;
  }
  .ml20{
    margin-left: 20px;
  }
  ::-webkit-input-placeholder { /* WebKit browsers */
    color:#808080;
    font-size: 16px;
    font-family: "Source Han Sans CN Normal";
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:#808080;
    font-size: 16px;
    font-family: "Source Han Sans CN Normal";
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:#808080;
    font-size: 16px;
    font-family: "Source Han Sans CN Normal";
  }
  :-ms-input-placeholder { /* Internet Explorer 10+ */
    color:#808080;
    font-size: 16px;
    font-family: "Source Han Sans CN Normal";
  }

  .content{
    width: 1201px;
    height: 515px;
    margin: 59px auto;
    padding: 0 41px 0 53px;
    box-sizing: border-box;
    background-color: #fff;
  }
  .content .top{
    padding: 83px 0 70px 0;
    box-sizing: border-box;
  }
  .content .top>span{
    font-size: 18px;
    color: #333;
  }
  .content .top span.top_left{
    width: 90px;
    display: inline-block;
    font-family: "Source Han Sans CN Normal";
  }
  .content .top span.top_right{
    margin-left: 20px;
    font-family: "Source Han Sans CN Medium";
  }
  /*--------------账号密码、安全手机样式---------------*/
  .item{
    padding: 46px 0;
    box-sizing: border-box;
    border-top: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .item_left{
    display: flex;
    align-items: center;
  }
  .item_left img{
    width: 32px;
    height: 32px;
  }
  .item_left .pass_word{
    font-size: 18px;
    font-family: "Source Han Sans CN Normal";
    color: #333;
  }
  .item_left .safe{
    font-size: 14px;
    font-family: "Source Han Sans CN Normal";
    color: #333;
  }
  .item_left .number{
    font-size: 18px;
    font-family: "Source Han Sans CN Normal";
    color: #21a26e;
  }
  .item_right{
    width: 131px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: #b30000;
    border: 1px solid #d2d2d2;
    border-radius: 3px;
    font-size: 16px;
    font-family: "Source Han Sans CN Normal";
    cursor: pointer;
  }
  /*--------------遮罩样式-----------*/
  .master{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 666;
    background-color: rgba(0,0,0,.4);
  }
  /*------------修改密码---------*/
  .change_password{
    width: 440px;
    height: 500px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -220px;
    margin-top: -250px;
    background-color: #fff;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .title{
    height: 56px;
    line-height: 56px;
    text-align: center;
    border-bottom: 1px solid #d2d2d2;
    font-size: 18px;
    font-family: "Source Han Sans CN Regular";
    box-sizing: border-box;
  }
  .el-icon-circle-close-outline{
    font-size: 19px;
    margin-top: 19px;
  }
  .details{
    padding: 50px;
    box-sizing: border-box;
  }
  .details input{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    border: 1px solid #d2d2d2;
    padding: 0 20px;
    box-sizing: border-box;
    font-family: "Source Han Sans CN Normal";
  }
  .details .code{
    font-size: 16px;
    color: #000000;
    font-family: "Source Han Sans CN Normal";
  }
  .details .illustrate{
    font-size: 12px;
    color: #787878;
    font-family: "Source Han Sans CN Normal";
  }
  .btn{
    display: flex;
    justify-content: space-between;
    padding: 0 50px;
    box-sizing: border-box;
  }
  .btn button{
    width: 152px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border-radius: 2px;
    font-size: 18px;
    font-family: "Source Han Sans CN Normal";
  }
  .btn button.cancel{
    color: #000;
    border: 1px solid #e5e5e5;
    background-color: #fff;
  }
  .btn button.sure{
    color: #fff;
    border: 1px solid #06B570;
    background-color: #06B570;
  }
  /*-------------绑定手机------------*/
  /*发送短信*/
  .binding_phone{
    width: 440px;
    height: 309px;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -220px;
    margin-top: -155px;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .auth_code{
    font-size: 15px;
    color: #000;
    line-height: 25px;
    font-family: "Source Han Sans CN Normal";
  }
  .phone_num{
    font-size: 15px;
    color: #05b570;
    font-family: "Source Han Sans CN Normal";
  }
  .send{
    width: 100%;
    height: 46px;
    line-height: 46px;
    font-size: 18px;
    color: #FFFFFF;
    background-color: #05b570;
    margin-top: 33px;
  }
  /*验证验证码*/
  .validation{
    width: 440px;
    /*height: 347px;*/
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 30%;
    margin-left: -220px;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .box{
    display: flex;
    margin-top: 28px;
  }
  input.randCode{
    width: 204px;
    height: 44px;
    line-height: 44px;
  }
</style>
<style>
  #personalCenter .sendBtn{
    width: 116px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: 14px;
    margin: 0;
    color: #000;
    font-family: "Source Han Sans CN Normal";
    background-color: #d2d2d2;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/personalCenter.vue